module.exports = __webpack_public_path__ + "img/vizio3-cover-3.c31b6854.jpg";